import React from 'react';
import Image from 'next/image';
import styles from './index.module.less';

const WhyYouNeed: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-search-works'];
  if (!showContent.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{showContent.title}</h2>
      {showContent.desc && <p className={styles.desc}>{showContent.desc}</p>}
      <div className={styles.cardsGrid}>
        {showContent.cards.map((card: any, index: number) => (
          <div key={card.title || index} className={styles.card}>
            {card.imgPath && (
              <div className={styles.iconWrapper}>
                <Image src={card.imgPath} alt={card.title || ''} width={32} height={32} className={styles.icon} />
                <h3 className={styles.cardTitle}>{card.title}</h3>
              </div>
            )}
            <p className={styles.cardDesc}>{card.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyYouNeed;
